import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFields } from '~/components/FormFields';

const UserActivationResetPassword = () => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  return (
    <>
      <FormFields.Checkbox
        control={control}
        checkboxValue={1}
        defaultValue={0}
        name='sendDocumentsOnVerification'
        label={t('Send terms of use, data privacy etc. after successful initial activation?')}
      />
      <FormFields.Checkbox
        control={control}
        checkboxValue={1}
        defaultValue={0}
        name='sendDocumentsOnResetPassword'
        label={t('Send terms of use, data privacy etc. when resetting your password?')}
      />
    </>
  );
};

export default UserActivationResetPassword;
